export const getProviderRates = (params) => async (dispatch, getState, api) => {
    try {
        return await api.get(`/providers/rates/${params}`);
    } catch (err) {
        return undefined;
    }
};